import { Card } from './Card/Card';
import { setNextFlow } from '../../../../../hooks/setNextFlow';
import { ChapterState, DestinationVariants } from '../../../../../../../../../../../lib/models/TemplateTypes';
import { getChapterRecommendedProducts } from '../../../../Sidebar/ChapterList/getChapterRecommendedProducts';

const LAST_TWO_CHAPTERS = 2;

export function Cards({
  pagesFlow,
  chapterIconMedia,
  setPagesFlow,
  setPageHistory,
  currentElements,
  fonts,
  colors,
  productInformation,
  resultProducts,
}) {
  const { allChapters, allPages } = pagesFlow;
  const allChaptersWithoutCompletedChapters = allChapters.filter(item => !item.content.completedChaptersButtons);

  const handleGoChapter = (chapterId, flowObj, rules, stateObj, pageUid) => {
    if ([ChapterState.COMPLETED, ChapterState.OPENED].includes(stateObj)) {
      const nextPage =
        flowObj?.goTo === DestinationVariants.NEXT
          ? allPages.find(page => page.id === pageUid)
          : allPages.find(page => page.elements.find(el => el.id === flowObj?.goTo));

      setNextFlow(flowObj, rules, nextPage, chapterId, pagesFlow, setPagesFlow, setPageHistory, currentElements);
    }
  };

  return (
    <div>
      {allChaptersWithoutCompletedChapters?.map((chapter, index) => {
        const nextChapter = allChaptersWithoutCompletedChapters[index + 1];
        const connection = chapter.content?.chapterConnection;
        const connectionLabel = connection?.label;

        const shouldShowConnection = connection && connection.targetChapterId && nextChapter && connection.targetChapterId === nextChapter.id;
        // HARDCODED: Always show frame for the last 2 chapters (second to last)
        const isSecondToLast = index === allChaptersWithoutCompletedChapters.length - LAST_TWO_CHAPTERS;
        const { recommendedProductIds } = getChapterRecommendedProducts(chapter, pagesFlow);
        return (
          <Card
            key={chapter.id}
            chapter={chapter}
            index={index}
            chapterIconMedia={chapterIconMedia}
            handleGoChapter={handleGoChapter}
            fonts={fonts}
            colors={colors}
            productInformation={productInformation}
            pagesFlow={pagesFlow}
            shouldShowConnection={shouldShowConnection}
            connectionLabel={connectionLabel}
            resultProducts={resultProducts}
            recommendedProductIds={recommendedProductIds}
            isSecondToLast={isSecondToLast}
          />
        );
      })}
    </div>
  );
}
